module.exports = __webpack_public_path__ + "img/Metastasis-GBM_GSE194329.28410124.png";